const onlyNumberValue = (value) => {
	if (value) {
		return value.replace(/\D/g, "");
	}
};

const capitalize = (word) => {
	if (word) return word.charAt(0) + word.slice(1).toLowerCase();
	else return word;
};

const createLocalDate = (dateString) => {
    // Dividir a string da data para obter o ano, mês e dia
    const [year, month, day] = dateString.split('-').map(Number);

    // Criar um objeto de data no fuso horário local
    const date = new Date(year, month - 1, day);

    return date;
}

const formatDate = (value) => {
	if (value) {

		if (value instanceof Date) {
			const year = value.getFullYear();
			const month = String(value.getMonth() + 1).padStart(2, "0"); // `getMonth()` retorna 0-indexado
			const day = String(value.getDate()).padStart(2, "0");
			return `${day}/${month}/${year}`;
		} else if (typeof value === "string") {
			const [year, month, day] = value.split("-");
			return `${day}/${month}/${year}`;
		} else {
			return null;
		}
	}
	return null;
};

const formatCpf = (value) => {
	if (value) {
		value = value.replace(/\D/g, "");

		if (value.length <= 11) {
			value = value.replace(/(\d{3})(\d)/, "$1.$2");
			value = value.replace(/(\d{3})(\d)/, "$1.$2");
			value = value.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
		}
	}

	return value;
};

const validateCpf = (cpf) => {
	if (typeof cpf !== "string") return false;
	cpf = cpf.replace(/[\s.-]*/gim, "");
	if (
		!cpf ||
		cpf.length !== 11 ||
		cpf === "00000000000" ||
		cpf === "11111111111" ||
		cpf === "22222222222" ||
		cpf === "33333333333" ||
		cpf === "44444444444" ||
		cpf === "55555555555" ||
		cpf === "66666666666" ||
		cpf === "77777777777" ||
		cpf === "88888888888" ||
		cpf === "99999999999"
	) {
		return false;
	}
	var soma = 0;
	var resto;
	for (var i = 1; i <= 9; i++)
		soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
	resto = (soma * 10) % 11;
	if (resto === 10 || resto === 11) resto = 0;
	if (resto !== parseInt(cpf.substring(9, 10))) return false;
	soma = 0;
	for (i = 1; i <= 10; i++)
		soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
	resto = (soma * 10) % 11;
	if (resto === 10 || resto === 11) resto = 0;
	if (resto !== parseInt(cpf.substring(10, 11))) return false;
	return true;
};

function validateEmail(email) {
	if (email) {
		const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		return regex.test(email);
	}
}

function parseCurrency(value) {
	if (value) {
		// Remove os pontos de separação de milhares
		value = value.toString().replace(/\./g, "");
		// Substitui a vírgula decimal por um ponto
		value = value.replace(/,/g, ".");
		// Converte a string para um número
		return parseFloat(value);
	} else return value;
}

function toPtCurrency(value) {
	if (value != null)
		return value.toLocaleString("pt-BR", {
			style: "currency",
			currency: "BRL",
		});
	else return 0;
}

function toPercent(value) {
	if (value) {
		let valorNum = parseFloat(value.toString().replace(",", "."));

		return `${valorNum}%`;
	}
	return 0;
}
function formatPhone(value) {
	if (value) {
		value = value.replace(/\D/g, ""); // Remove all non-digit characters

		if (value.length > 0) {
			value = "(" + value;
		}
		if (value.length > 3) {
			value = value.slice(0, 3) + ") " + value.slice(3);
		}
		if (value.length > 10) {
			value = value.slice(0, 10) + "-" + value.slice(10);
		}
		if (value.length > 15) {
			value = value.slice(0, 15); // Limit to the mask length
		}
		return value;
	}
	return null;
}

function formatToDecimal(numero) {
	return numero.toFixed(2); // Formata o número para duas casas decimais
}

function validateCVV(cvv, cardType) {
	// Remover espaços em branco se houver
	cvv = cvv.trim();

	// Expressão regular para validar o CVV
	let cvvRegex;
	switch (cardType) {
		case "Visa":
		case "MasterCard":
		case "Discover":
			cvvRegex = /^[0-9]{3}$/; // CVV com 3 dígitos para Visa, MasterCard, Discover
			break;
		case "American Express":
			cvvRegex = /^[0-9]{4}$/; // CVV com 4 dígitos para American Express
			break;
		default:
			return false; // Tipo de cartão não reconhecido
	}

	// Validar o CVV com a expressão regular
	return cvvRegex.test(cvv);
};

function validatePhoneNumber(phoneNumber) {
	// Formato Brasileiro: (XX) XXXXX-XXXX ou (XX) XXXX-XXXX ou XX XXXXX-XXXX ou XX XXXX-XXXX
	const phoneRegex = /^(\(?\d{2}\)?\s?)?(\d{4,5}-?\d{4})$/;

	return phoneRegex.test(phoneNumber);
}


export const formatterService = {
	onlyNumberValue,
	capitalize,
	formatDate,
	formatCpf,
	validateCpf,
	parseCurrency,
	toPtCurrency,
	toPercent,
	formatPhone,
	validateEmail,
	formatToDecimal,
	validateCVV,
	validatePhoneNumber,
	createLocalDate,
};
